import { http } from '../http';

export interface ShiftRow {
  id: string;
  code: string;
  name: string;
  company: string;
  /** `null` = el turno aplica a toda la empresa. */
  area: string | null;
  startTime: string;
  endTime: string;
  crossesMidnight: boolean;
  toleranceMinutes: number;
  /** 1 = lunes … 7 = domingo. */
  weekDays: number[];
  validFrom: string;
  validTo: string | null;
  /** `CALCULATED` = derivado de las marcaciones. `MANUAL` = contractual. */
  source: string;
  isActive: boolean;
}

export async function fetchShifts(): Promise<{ shifts: ShiftRow[] }> {
  const response = await http.get<{ shifts: ShiftRow[] }>('/shifts');
  return response.data;
}
